import React, { useState } from "react";
import { Typography, Flex, Button } from "antd";
import {
  ShieldCheckIcon,
  BookmarkIcon,
  ArrowDownTrayIcon,
} from "@heroicons/react/24/outline";
import { useBookmarkToggle } from "../../hooks/useBookmarkToggle";
import { CatalogItem } from "../../types";
import SpecimenDownloadModal from "./SpecimenDownloadModal";

const { Text } = Typography;

interface SpecimenHeaderProps {
  id: string | undefined;
  displayTitle: string | undefined;
  isMeshRoute: boolean;
  catalogItem: CatalogItem | undefined;
  onDownload: () => void;
}

const SpecimenHeader: React.FC<SpecimenHeaderProps> = ({
  id,
  displayTitle = "",
  isMeshRoute,
  catalogItem,
  onDownload,
}) => {
  const { isBookmarking, handleToggleBookmark } = useBookmarkToggle({
    catalogItem: catalogItem!,
  });

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  return (
    <>
      <Flex justify="space-between" align="center">
        <div>
          <Text className="text-[40px]! leading-10!">{displayTitle}</Text>
          <Flex
            align="center"
            gap="8px"
            className={`pt-2! text-[#0C4A6E] ${isMeshRoute ? "invisible" : ""}`}
          >
            <ShieldCheckIcon className="w-5 h-5" />
            <Text className="text-[#0C4A6E] font-medium">
              Mosquito detected by Vectech Scout
            </Text>
          </Flex>
        </div>

        <Flex gap="16px">
          <Button
            type="primary"
            loading={isBookmarking}
            onClick={handleToggleBookmark}
            disabled={!catalogItem}
            className={catalogItem?.is_bookmarked ? "bg-[#005F8F]!" : ""}
          >
            <Flex align="center" justify="center" gap="8px">
              {catalogItem?.is_bookmarked ? (
                <BookmarkIcon
                  className="w-5 h-5  border-[#ffffff] "
                  fill="#005F8F"
                />
              ) : (
                <BookmarkIcon className="w-5 h-5 text-[#FFFFFF]" />
              )}
              {catalogItem?.is_bookmarked ? "Bookmarked" : "Bookmark"}
            </Flex>
          </Button>
          <Button type="primary" onClick={() => setIsDownloadModalOpen(true)}>
            <Flex align="center" justify="center" gap="8px">
              <ArrowDownTrayIcon className="w-5 h-5" />
              Download
            </Flex>
          </Button>
        </Flex>
      </Flex>

      <SpecimenDownloadModal
        open={isDownloadModalOpen}
        onCancel={() => setIsDownloadModalOpen(false)}
        onDownload={() => {
          onDownload();
          setIsDownloadModalOpen(false);
        }}
        isMeshRoute={isMeshRoute}
      />
    </>
  );
};

export default SpecimenHeader;
